module.exports = __webpack_public_path__ + "static/media/look-back-plan-ahead.a4068aed.svg";